import {
  getLocalDeliveryRate,
  isLocalDeliveryAddress,
} from './shippingPolicy';

export const addDecimals = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

/** Format a price value to 2 decimal places, treating null/undefined as 0. */
export const fmt = (n) => Number(n ?? 0).toFixed(2);

export const updateCart = (state) => {
  const getUnitPrice = (item) => {
    if (item?.tierPriceApplied || item?.ignoreSale) {
      return Number(item?.price ?? 0);
    }
    const rp = Number(item?.originalPrice ?? item?.price ?? 0);
    const sp = Number(item?.salePrice ?? 0);
    const start = item?.saleStartAt ? new Date(item.saleStartAt) : null;
    const end = item?.saleEndAt ? new Date(item.saleEndAt) : null;
    const now = new Date();
    const hasSale =
      sp > 0 &&
      sp < rp &&
      (!start || Number.isNaN(start.getTime()) || now >= start) &&
      (!end || Number.isNaN(end.getTime()) || now <= end);
    return hasSale ? sp : rp;
  };
  // Be resilient to null/undefined prices & qty
  const sum = state.cartItems.reduce(
    (acc, item) => acc + getUnitPrice(item) * Number(item?.qty ?? 0),
    0
  );

  // Items price
  state.itemsPrice = Number(sum).toFixed(2);

  // Shipping price (local delivery policy, $0 for pickup)
  const isPickup = (state.fulfillmentMethod || 'ship') === 'pickup';
  const isLocalDelivery = isLocalDeliveryAddress(
    state.shippingAddress
  );
  const localRate = getLocalDeliveryRate(
    Number(state.itemsPrice)
  );
  state.shippingPrice = Number(
    isPickup
      ? 0
      : isLocalDelivery
      ? localRate
      : 0
  ).toFixed(2);

  // Tax price
  state.taxPrice = Number((0.13 * Number(state.itemsPrice)).toFixed(2));

  // Total price
  state.totalPrice = (
    Number(state.itemsPrice) +
    Number(state.shippingPrice) +
    Number(state.taxPrice)
  ).toFixed(2);

  // Persist ALL relevant cart state so navigation doesn’t lose context
  localStorage.setItem(
    'cart',
    JSON.stringify({
      cartItems: state.cartItems,
      shippingAddress: state.shippingAddress,
      paymentMethod: state.paymentMethod,
      itemsPrice: state.itemsPrice,
      shippingPrice: state.shippingPrice,
      taxPrice: state.taxPrice,
      totalPrice: state.totalPrice,
      // ✅ new persisted fields
      guestMode: Boolean(state.guestMode),
      guestInfo: state.guestInfo || {},
      ownerUserId: state.ownerUserId || null,
      fulfillmentMethod: state.fulfillmentMethod || 'ship',
      pickupLocation: state.pickupLocation || null,
    })
  );

  return state;
};
